import { render } from "./thar-banner.vue?vue&type=template&id=0b4e84b4&scoped=true"
import script from "./thar-banner.vue?vue&type=script&lang=js"
export * from "./thar-banner.vue?vue&type=script&lang=js"

import "./thar-banner.vue?vue&type=style&index=0&id=0b4e84b4&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4e84b4"]])

export default __exports__